import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  const dialogMinWidth = 240;

  return createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 190,
      maxWidth: 190
    },
    dialog: {
      overflow: 'hidden'
    },
    closeDialogBtn: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1)
    },
    spinnerBox: {
      minWidth: dialogMinWidth,
      minHeight: 150,
      display: 'flex',
      justifyContent: 'center'
    },
    updateForm: {
      minWidth: dialogMinWidth
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    }
  });
});
